import React, { useContext } from "react"
import ReactErrorBoundary from "react-error-boundary"
import { Context as RollbarReactContext, getRollbarFromContext } from "@rollbar/react"
import { ReactComponent as LogoIcon } from "../../icons/bandnada-logo.svg"

const MyFallbackComponent = ({ componentStack, error }) => (
  <div className="p-2">
    <LogoIcon className="lg:w-1/12 w-1/3 mb-4" />
    <details>
      <summary>
        <strong>Ruh Roh. We didn't see that coming 😬</strong>
        <p>
          If you continue to get this error please email{" "}
          <strong>support@bandnada.com</strong> explaining what you were trying
          to do when you got this error and please copy and paste the error too.
        </p>
        <p>
          <strong>Error:</strong> {error?.message || "unknown error"}
        </p>
      </summary>

      {location.hostname === "localhost" && (
        <>
          <div>
            <strong>Components:</strong> <pre>{componentStack}</pre>
          </div>
          <div>
            <strong>Stacktrace:</strong> <pre>{error?.stack}</pre>
          </div>
        </>
      )}
    </details>
  </div>
)

export const ErrorBoundary = props => {
  const rollbarCtx = useContext(RollbarReactContext)
  const rollbar = rollbarCtx ? getRollbarFromContext(rollbarCtx) : null

  const handleError = (error, componentStack) => {
    if (rollbar?.options?.enabled) {
      rollbar.error(error, { componentStack })
    }
  }

  return (
    <ReactErrorBoundary
      onError={handleError}
      FallbackComponent={MyFallbackComponent}
      env={props.env}
      {...props}
    />
  )
}
